/** Fixed IDR rate per USD for an account: 14000 -> "Rp 14.000". Missing -> "-". */
export function formatIdrRate(rate: number | null | undefined): string {
  if (rate == null || !Number.isFinite(rate) || rate <= 0) return '-'
  return `Rp ${rate.toLocaleString('id-ID')}`
}
